import {create} from 'zustand';
import {IFile} from '../../../../components/UploadRefundFiles/types';

type UsePendingRefundUploadsStoreProps = {
	pendingFiles: IFile[];
	setPendingFiles: (files: IFile[]) => void;
	addPendingFile: (file: IFile) => void;
	updatePendingFile: (id: string, updates: Partial<IFile>) => void;
	removePendingFile: (id: string) => void;
	resetPendingFiles: () => void;
};

export const usePendingRefundUploadsStore = create<UsePendingRefundUploadsStoreProps>(set => ({
	pendingFiles: [],
	setPendingFiles: files => set({pendingFiles: files}),
	addPendingFile: file =>
		set(state => ({
			pendingFiles: [...state.pendingFiles, file],
		})),
	updatePendingFile: (id, updates) =>
		set(state => ({
			pendingFiles: state.pendingFiles.map(file =>
				file.id === id ? {...file, ...updates} : file,
			),
		})),
	removePendingFile: id =>
		set(state => ({
			pendingFiles: state.pendingFiles.filter(file => file.id !== id),
		})),
	resetPendingFiles: () => set({pendingFiles: []}),
}));
